import { Component } from '@angular/core';

/**
 * Generated class for the LubbuContentComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'lubbu-content',
  templateUrl: 'lubbu-content.html'
})
export class LubbuContentComponent {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/lubbu-content/lubbu-content.ts